import React from 'react'
import PropTypes from 'prop-types'
import { Disqus } from 'gatsby-plugin-disqus'

const DisqusComments = ({ slug, title, url }) => {

  let disqusConfig = {
    url: url,
    identifier: slug,
    title: title
  }
  return (
    <>
      {/* enable the below commentCount component if you want to show count of comments  */}
      {/* <CommentCount config={disqusConfig} placeholder={"..."} /> */}
      {/* Post Contents */}
      <Disqus config={disqusConfig} sx={{ variant: 'styles' }} />
    </>
  )
}

DisqusComments.propTypes = {
  slug: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string
}

export default DisqusComments
